export default "__VITE_ASSET__BqrN1EXr__"